import Hirarki from './Hirarki';

export default Hirarki;
